import { render, staticRenderFns } from "./StudyOneModal.vue?vue&type=template&id=13529958&scoped=true"
import script from "./StudyOneModal.vue?vue&type=script&lang=js"
export * from "./StudyOneModal.vue?vue&type=script&lang=js"
import style0 from "./StudyOneModal.vue?vue&type=style&index=0&id=13529958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13529958",
  null
  
)

export default component.exports